export default __webpack_public_path__ + "static/media/LOGOIOCL.551a2239.png";